import React, { CSSProperties } from 'react'
import { Icon } from '../Icon'

interface subHeading {
  mainPage: string
  subPage?:
    | string
    | Array<{
        id: string
        name: string
      }>
  copy?: string
  isDelete?: boolean
  isAccess?: boolean
  isEdit?: boolean
  onCreate?: () => void
  onEdit?: () => void
  onEdit2?: () => void
  onDelete2?: () => void
  onPublish?: () => void
  onUnPublish?: () => void
  onDelete?: () => void
  isViewMode: boolean
  isCreatePolicy?: boolean
  isButton?: boolean
  buttonLable?: string
  buttonIcon?: string
  isButtonOnClick?: () => void

  isButton2?: boolean
  buttonLable2?: string
  buttonIcon2?: string
  isButtonOnClick2?: () => void
  customDescriptionStyle?: CSSProperties
  onBack?: () => void
  publishButtonTitle?: string
  onPrevious?: () => void
}

const UISubHeaderComponent = (props: subHeading) => {
  return (
    <div className={'flex w-full justify-between items-start '}>
      <div className="flex-col   gap-[20px]">
        <div className="flex w-[100%] items-center gap-[10px]">
          <span
            onClick={props.onBack}
            className={'text-[18px] text-text1 font-bold cursor-pointer'}
          >
            {props.mainPage}
          </span>
          <span className="text-text1">
            <Icon
              name={'IconChevronRight'}
              stroke={'#02698C'}
              height={12}
              width={12}
            />
          </span>
          <p className={'text-[18px] text-text2 flex items-center '}>
            {Array.isArray(props.subPage) ? (
              Array.isArray(props.subPage) && props.subPage.length > 1 ? (
                <>
                  {props.subPage.length > 1 && (
                    <span
                      onClick={props.onPrevious}
                      className="text-text1 cursor-pointer font-bold flex items-center"
                    >
                      ...{' '}
                      <Icon
                        name={'IconChevronRight'}
                        stroke={'#02698C'}
                        height={12}
                        width={12}
                      />
                    </span>
                  )}
                  {props.subPage.slice(-2).map((item, index) => (
                    <React.Fragment key={item.id}>
                      {index > 0 && (
                        <span
                          className="text-text1"
                          style={{ cursor: 'context-menu' }}
                        >
                          <Icon
                            name={'IconChevronRight'}
                            stroke={'#02698C'}
                            height={12}
                            width={12}
                          />
                        </span>
                      )}
                      <span
                        className="text-text1  font-bold"
                        style={{ cursor: 'context-menu' }}
                      >
                        {item.name}
                      </span>
                    </React.Fragment>
                  ))}
                </>
              ) : (
                // Handle case when there's only one or no elements
                props.subPage &&
                props.subPage.map((item) => (
                  <span
                    key={item.id}
                    className="text-text1  font-bold"
                    style={{ cursor: 'context-menu' }}
                  >
                    {item.name}
                  </span>
                ))
              )
            ) : (
              <span
                className="text-text1 cursor-pointer font-bold"
                style={{ cursor: 'context-menu' }}
              >
                {props.subPage}
              </span>
            )}
          </p>
        </div>
        <div
          style={props?.customDescriptionStyle}
          className="flex w-[100%] items-center gap-[10px]"
        >
          <p
            className={'text-[14px] font-normal text-text1 leading-[24px] my-2'}
          >
            {props.copy}
          </p>
        </div>
      </div>

      {props.isViewMode && (
        <div className={'flex flex-row gap-[15px]'}>
          {props.onDelete && (
            <div
              onClick={props.onDelete}
              className=" items-center justify-between min-w-[112px] border border-gray2 text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer "
            >
              <p className={'font-medium text-[14px] text-text1'}>Delete</p>
              <Icon
                name={'IconTrash'}
                strokeWidth={1}
                stroke={'#02698C'}
                width={16}
                height={16}
              />
            </div>
          )}
          {props.onEdit && (
            <div
              onClick={props.onEdit}
              className=" bg-gray2 items-center justify-between min-w-[95px] border border-gray2 text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer "
            >
              <p className={'font-medium text-[14px] text-text1'}>Edit</p>
              <Icon
                name={'IconEdit'}
                strokeWidth={1}
                stroke={'#02698C'}
                width={16}
                height={16}
              />
            </div>
          )}
          {props?.isButton2 && (
            <div
              onClick={props?.isButtonOnClick2}
              className="gap-[10px] bg-gray2 items-center justify-between min-w-[95px] text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer "
            >
              <p className={'font-medium text-[14px] text-text1'}>
                {props?.buttonLable2}
              </p>
              <Icon
                name={props?.buttonIcon2 ? props?.buttonIcon2 : ''}
                strokeWidth={1}
                stroke={'#02698C'}
                width={16}
                height={16}
              />
            </div>
          )}

          {props.onPublish && (
            <div
              onClick={props.onPublish}
              className=" bg-bluishGreen  items-center justify-between w-fit gap-[10px] border border-gray2 text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer "
            >
              <p className={'font-medium text-[14px] text-white'}>
                {props.publishButtonTitle || 'Change Status'}
              </p>
              <Icon
                name={'IconFileMinus'}
                strokeWidth={1.5}
                stroke={'#FFFFFF'}
                width={16}
                height={16}
              />
            </div>
          )}
        </div>
      )}

      {props.isAccess && (
        <div className={'flex flex-row gap-[15px]'}>
          {props.isDelete && (
            <div
              onClick={props.onDelete2}
              className=" items-center justify-between min-w-[112px] border border-gray2 text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer "
            >
              <p className={'font-medium text-[14px] text-text1'}>Delete</p>
              <Icon
                name={'IconTrash'}
                strokeWidth={1}
                stroke={'#02698C'}
                width={16}
                height={16}
              />
            </div>
          )}
          {props.isEdit && (
            <div
              onClick={props.onEdit2}
              className=" bg-gray2 items-center justify-between min-w-[95px] border border-gray2 text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer "
            >
              <p className={'font-medium text-[14px] text-text1'}>Edit</p>
              <Icon
                name={'IconEdit'}
                strokeWidth={1}
                stroke={'#02698C'}
                width={16}
                height={16}
              />
            </div>
          )}
        </div>
      )}

      {props?.isButton && (
        <div
          onClick={props?.isButtonOnClick}
          className="gap-[10px] bg-bluishGreen items-center justify-between min-w-[95px] text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer "
        >
          <p className={'font-medium text-[14px] text-white'}>
            {props?.buttonLable}
          </p>
          <Icon
            name={props?.buttonIcon ? props?.buttonIcon : ''}
            strokeWidth={1}
            stroke={'white'}
            width={16}
            height={16}
          />
        </div>
      )}

      {!props.isViewMode && props?.isCreatePolicy && (
        <button
          onClick={props.onCreate}
          className=" bg-bluishGreen text-white h-12 w-[158px] font-medium rounded-[72px] text-[14px]  "
        >
          Create policy
        </button>
      )}
    </div>
  )
}

export default UISubHeaderComponent
